import React from "react";

const AdminContent = ({ children }) => {
    return <div className="admin-content">{children}</div>;
};

export default AdminContent;
